import { Controller } from "@hotwired/stimulus"
import Highcharts from 'highcharts'
import HighchartsMoreFn from 'highcharts/highcharts-more'
import HighchartsAccessibilityFn from 'highcharts/modules/accessibility'

HighchartsMoreFn(Highcharts)
HighchartsAccessibilityFn(Highcharts)

// Connects to data-controller="simple-spider-chart"
export default class extends Controller {
  static values = {
    data: Array,
    width: { type: Number, default: 70 },
    height: { type: Number, default: 70 }
  }

  connect() {
    this.createSpiderWebChart();
  }

  createSpiderWebChart(){
    const CHART_SHOW_HASH = {
      sharp: 'シャープレシオ',
      reward: '実質信託報酬',
      sellbank: '販売会社数',
      return: '利回り(リターン)',
      stdevy: '標準偏差',
      popular: '注目度'
    }
    let sideVisible = false;
    let sideEnabled = false;
    let hoverEnabled = false;
    let sideSize= '100%';
    let sideDistance = 0;
    let sideMarginLeft = -2.6;
    let maxNum = 100;
    let seriesData = [{
      name: '値',
      data: this.dataValue,
      pointPlacement: 'off',
      lineWidth: 1.3,
      marker:{
        radius: 1.4,
      }
    }];

    let chart = Highcharts.chart(this.element, {
      credits: {
        enabled: false
      },
      chart: {
        backgroundColor: 'transparent',
        polar: true,
        type: 'line',
        marginLeft: sideMarginLeft,
        height: this.heightValue,
        width: this.widthValue
      },
      title: {
        text: ''
      },
      xAxis: {
        categories: Object.values(CHART_SHOW_HASH),
        visible: sideVisible,
        tickmarkPlacement: 'on',
        lineWidth: 0,
        gridLineWidth: 0,
        labels: {
          style: {
            fontFamily: "-apple-system,\'BlinkMacSystemFont\',\'Hiragino Kaku Gothic ProN\',\'Noto Sans CJK JP\',\'Noto Sans JP\',\'Noto Sans\',sans-serif",
            fontSize: '11px',
            fontWeight: 'bold',
            color: '#64748B'
          },
          distance: sideDistance
        }
      },
      yAxis: {
        gridLineInterpolation: 'polygon',
        // gridLineColor: "#CBD5E1",
        gridLineWidth: 0,
        lineWidth: 0,
        min: 0,
        max: maxNum,
        tickAmount: 3,
        labels: {
          enabled: false
        },
      },
      tooltip: {
        enabled: sideEnabled,
        formatter: function () {
          var tooltip = ''
          tooltip = '<span style="font-size: 10px">' + this.x + '</span><br>' +
          '<span style="fill:' + this.color + '">● </span><span style="font-weight: bold">' + this.y + 'pt' + '</span></span>'
          return tooltip;
        }
      },
      legend: {
        enabled: false
      },
      pane: {
        size: sideSize
      },
      plotOptions: {
        series: {
          states: {
            hover: {
              enabled: hoverEnabled
            }
          }
        }
      },
      series: seriesData
    });

    let colors = ["#CBD5E1", "#E2E8F0", "#F1F5F9", "#F8FAFC"];
    let parts = 6;
    let interval = 6;
    for(let i = 0; i < colors.length; i++) {
      let centerX = chart.plotLeft + chart.yAxis[0].center[0];
      let centerY = chart.plotTop + chart.yAxis[0].center[1];
      let axisLength = chart.yAxis[0].height - interval * i;
      let angleOffset = -Math.PI / 2;
      let angleSegment = Math.PI / (parts / 2);
      for(let j = 0; j < parts; j++) {
        let firstPointX = centerX + (axisLength * Math.cos(angleOffset + (angleSegment * j)));
        let firstPointY = centerY + (axisLength * Math.sin(angleOffset + (angleSegment * j)));
        let secondPointX = centerX + (axisLength * Math.cos(angleOffset + (angleSegment * (j + 1))));
        let secondPointY = centerY + (axisLength * Math.sin(angleOffset + (angleSegment * (j + 1))));
        chart.renderer.path([
          'M', centerX, centerY,
          'L', firstPointX, firstPointY,
          'L', secondPointX, secondPointY,
          'Z'
        ]).attr({
          fill: colors[i],
          'stroke-width': 0,
          'opacity': 1
        }).add();
      }
    }

  }
}
